export default "__VITE_ASSET__3r6PdJi8__"